import { ComingSoonSection } from "../ComingSoonSection"

export const CustomerDashboardMessages = () => {
  return (
    <ComingSoonSection
      title="Messages are on the way."
      subtitle="This section will soon provide detailed information about the scheduled messages and the delivery history."
    />
  )
}
